import { Action } from '@ngrx/store';
import { CampaignSummaryResult, PaginationInfo, CampaignListingRequestInfo, SortingInfo } from '../campaign';

export enum LiveCampaignActionTypes {
    loadCampaigns = '[Live Campaigns] Load campaigns',
    loadCampaignsSuccess = '[Live Campaigns] Load campaigns success',
    loadCampaignsFail = '[Live Campaigns] Load campaigns fail',
    setPaginationInfo = '[Live Campaigns] Set pagination info',
    setSortingInfo = '[Live Campaigns] Set sorting info',
    setIsloadingCampaigns = '[Live Campaigns] loading'
}

export class LoadCampaigns implements Action {
    readonly type = LiveCampaignActionTypes.loadCampaigns;
    constructor(public payload: CampaignListingRequestInfo) { }
}

export class LoadCampaignsSuccess implements Action {
    readonly type = LiveCampaignActionTypes.loadCampaignsSuccess;
    constructor(public payload: CampaignSummaryResult) { }
}

export class LoadCampaignsFail implements Action {
    readonly type = LiveCampaignActionTypes.loadCampaignsFail;
    constructor(public payload: string) { }
}

export class SetIsLoadingCampaigns implements Action {
    readonly type = LiveCampaignActionTypes.setIsloadingCampaigns;
}

export class SetPaginationInfo implements Action {
    readonly type = LiveCampaignActionTypes.setPaginationInfo;
    constructor(public payload: PaginationInfo) { }
}

export class SetSortingInfo implements Action {
    readonly type = LiveCampaignActionTypes.setSortingInfo;
    constructor(public payload: SortingInfo) { }
}

export type LiveCampaignActions = LoadCampaigns
    | LoadCampaignsSuccess
    | LoadCampaignsFail
    | SetIsLoadingCampaigns
    | SetSortingInfo
    | SetPaginationInfo;
